import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CronJobService {
  private apiUrl = `${environment.apiUrl}/cron-job`;

  constructor(private http: HttpClient) { }

  createCronJob(cronJob: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, cronJob);
  }

  getCronJobs(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getCronJob(id: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  updateCronJob(id: string, cronJob: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}`, cronJob);
  }

  deleteCronJob(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
